var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMs360Logo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4252518786212474 0 0 1.4252518786212474 250.00000000000003 250)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -48.163845802471855 -2.448150755351861)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(251,96,84)",
      fillRule: "nonzero",
      opacity: 0.83
    },
    transform: " translate(-89.68615419752814, -166.40184924464813)",
    d: "M 0 81.9 v 169 c 0 12.1 12.8 19.7 23.5 14.2 l 147.3 -77.6 c 11 -5.8 11.5 -21.3 1 -27.8 L 24.5 68.3 C 13.7 61.7 0 69.4 0 81.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.44936919195126 57.31793920344839)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(90,189,172)",
      fillRule: "nonzero",
      opacity: 0.83
    },
    transform: " translate(-176.29936919195126, -226.16793920344838)",
    d: "M 75.9 131.6 v 189.2 c 0 13.5 14.3 22.1 26.3 15.9 l 164.9 -86.9 c 12.3 -6.5 12.9 -23.8 1.1 -31.1 L 103.3 116.3 C 91.3 108.9 75.9 117.5 75.9 131.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.44936919195126 -56.26123154371126)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(127,130,188)",
      fillRule: "nonzero",
      opacity: 0.83
    },
    transform: " translate(-176.29936919195126, -112.58876845628873)",
    d: "M 75.9 18 v 189.2 c 0 13.5 14.3 22.1 26.3 15.9 l 164.9 -86.9 c 12.3 -6.5 12.9 -23.8 1.1 -31.1 L 103.3 2.8 C 91.3 -4.7 75.9 3.9 75.9 18 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs360Logo1);
export default __webpack_public_path__ + "static/media/ms360-logo-1.a4eae6a9456f1226534908218c706a0c.svg";
export { ForwardRef as ReactComponent };